import { number } from 'yup';

export const enum SubtitleRemovalMode {
  智能擦除 = 1,
  超级擦除 = 2,
}

export const subtitleRemovalModeOptions = [
  {
    label: '智能擦除（适合常规字幕/水印，速度非常快）',
    value: SubtitleRemovalMode.智能擦除,
  },
  {
    label: '超级擦除（功能全面，速度慢）',
    value: SubtitleRemovalMode.超级擦除,
  },
];

export const subtitleRemovalModeSchema = number<SubtitleRemovalMode>()
  .default(SubtitleRemovalMode.智能擦除)
  .required();
